import React, { useEffect, useState } from "react";
import { client } from "../config/prismic";

const AboutUs = () => {
  const [dates, setDates] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      const response = await client.getByType("about");
      setDates(response.results[0]?.data); // Accessing the first result's data directly
    };
    fetchData();
  }, []);

  if (!dates) {
    return (
      <div className="loader-container">
        <div className="loader"></div>
      </div>
    );
  }
  return (
    <section className="section-bg py-5 text-light px-3">
      <div className="about about-us-section container">
        <div className="container section-title mt-5" data-aos="fade-up">
          <h1 className="about-title text-red">{dates.title[0]?.text}</h1>
        </div>

        <div className="row mb-5">
          <div className="col-md-10 mx-auto text-center">
            {dates.description.map((para, index) => (
              <p
                key={index}
                className="about-description mb-4"
                style={{ fontSize: dates.description[0]?.fontSize }}
              >
                {para.text}
              </p>
            ))}
          </div>
        </div>

        <div className="flex-c flex-cb">
          <div className="col-md-5 px-2 mt-4">
            <h3 className="mb-4">Conference Details</h3>
            <ul className="list-unstyled">
              {/* <li>
                <i className="bi bi-hash"></i> Conference Record Number:{" "}
                <span className="text-info">
                  {dates.record_number[0]?.text}
                </span>
              </li>
              <li>
                <i className="bi bi-link-45deg"></i> Conference Approval Link:
                <a
                  href={dates.approval_link[0]?.text}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-decoration-underline text-info ms-2"
                >
                  View Link
                </a>
              </li> */}
              <li style={{ textAlign: "justify" }}>
                <i className="bi bi-bookmarks"></i> {dates.desc1[0]?.text}
              </li>
            </ul>
          </div>

          {/* Previous Conference Section */}
          <div className="col-md-5 px-2 text-md-end mt-4">
            <h3 className="mb-4">Previous Conference</h3>
            <p style={{ textAlign: "justify" }}>{dates.desc2[0]?.text}</p>
            <p style={{ textAlign: "justify" }}>
              <a
                href={dates.title1[0]?.spans[1]?.data.url}
                className="ml-2"
                target="_blank"
                rel="noopener noreferrer"
              >
                <strong>{dates.title1[0]?.text}</strong>
              </a>
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutUs;
